<form (submit)="f.form.valid && processRegion()" #f="ngForm" novalidate >
<div class="row">
    <!-- REGION NAME -->
    <div class="col-md-6">
        <div class="form-group padding-right-10">
            <mat-form-field>
                <input
                    placeholder="Region Name"
                    matInput
                    [(ngModel)]="region.name"
                    name="name"
                    #name="ngModel"
                    required
                    (keypress)="keyPressAlpha($event)"
                    maxlength="32"
                >
                <mat-error *ngIf="name.touched && name.errors?.pattern">Region name is not valid</mat-error>
            </mat-form-field>
        </div>
    </div>
    <!-- REGION ID -->
    <div class="col-md-6">
        <div class="form-group">
            <mat-form-field>
                <input
                    placeholder="Region ID"
                    matInput
                    [(ngModel)]="region.regionId"
                    name="regionID"
                    #regionID="ngModel"
                    (keypress)="keyPressAlpha($event)"
                    required
                    maxlength="6"
                >
                <mat-error *ngIf="f.touched && regionID.invalid">Region ID is required</mat-error>
            </mat-form-field>
        </div>
    </div>
</div>
<div class="margin-top-20 text-center">
    <button mat-raised-button color="primary" class="mat-button-large" type="submit" [disabled]="!f.valid">
        <span *ngIf="!region?.id">Create Region</span>
        <span *ngIf="region?.id">Update Region</span>
    </button>
</div>
</form>